














import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductGroupingDto } from '@/api';
import ProductGrid from '@/views/product/ProductGrid.vue';

@Component({
  components: {
    ProductGrid,
  },
})
export default class ProductGroupings extends Vue {
  @Prop({required: true})
  private groupings!: ProductGroupingDto[];
}
